/**
 * Browser file downloads: hand a Blob (or a base64 payload straight from the API) to the browser
 * as a saved file.
 *
 * This is what the `file-saver` package did for the Excel export, and what three attachment/CMR
 * download sites had already open-coded. The packaged version was lazy-loaded into its own chunk
 * named `FileSaver.min-<hash>.js`, which at least one customer's corporate network blocks by name
 * — the export then failed silently, forever, for that user. There is nothing here worth a
 * dependency and a separate chunk. (Sentry RINGIL-APP-P0.)
 */

/** Saves `blob` as `fileName` via a temporary object URL. */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);

  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  URL.revokeObjectURL(url);
};

/** Decodes a base64 payload (the shape our download endpoints return) and saves it as a file. */
export const downloadBase64File = (base64Data: string, mimeType: string, fileName: string): void => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  downloadBlob(new Blob([new Uint8Array(byteNumbers)], { type: mimeType }), fileName);
};
